<template>
  <div>
    <div class="custom-header__container">
      <page-header
        :actions="pageHeaderActionsConfig"
        left-side-class="mb-0 col-md-6"
        :page="pageHeaderConfig"
        right-side-class="col-sm-12 col-md-6 align-items-end d-flex pb-2 justify-content-end"
        style="flex: 1;"
      >
        <div class="d-flex">
          <div v-if="canDetermineProposalRequest && !showDetermination">
            <button
              v-if="canDetermineProposalRequest"
              aria-expanded="false"
              aria-haspopup="true"
              class="btn btn-dropdown-actions w-100 dropdown-toggle float-left color-white bg-green font-weight-bold d-flex justify-content-center align-items-center"
              data-toggle="dropdown"
              type="button"
            >
              <i class="fas fa-flag-alt mx-2 pr-1 mt-2" />
              <span class="mr-1">Determinar</span>
            </button>
            <div
              aria-labelledby="dropdownMenuButton"
              class="dropdown-menu dropdown-menu-right custom-dropdown-container"
            >
              <div
                v-if="canRecommendProposalRequest"
                class="dropdown-item cursor-pointer mb-1"
                @click="
                  onOpenDeterminationHandler(proposalRequestStatus.Recommended)
                "
              >
                <i class="fas fa-check text-green mr-2" />
                Recomendar
              </div>
              <div
                v-if="
                  isProvisionalRemedy &&
                    canRecommendProposalRequest &&
                    IsPartialRecomendationStatus
                "
                class="dropdown-item cursor-pointer mb-1"
                @click="
                  onOpenDeterminationHandler(
                    proposalRequestStatus.PartialRecommendation
                  )
                "
              >
                <i class="fas fa-check text-yellow mr-2" />
                Recomendado Parcial
              </div>
              <div
                v-if="canNotRecommendProposalRequest"
                class="dropdown-item cursor-pointer mb-1"
                @click="
                  onOpenDeterminationHandler(
                    proposalRequestStatus.NotRecommended
                  )
                "
              >
                <i class="fas fa-times-circle text-red mr-2" />
                No Recomienda
              </div>
              <div
                v-if="isProvisionalRemedy"
                class="dropdown-item cursor-pointer mb-1"
                @click="
                  onOpenDeterminationHandler(
                    proposalRequestStatus.RequirementsDoesNotAccomplish
                  )
                "
              >
                <i class="fas fa-times-circle text-red mr-2" />
                No Cumple Requisitos
              </div>
            </div>
          </div>
        </div>
      </page-header>
    </div>

    <proposal-request-determination
      v-if="showDetermination"
      class="mb-3"
      :determination-status-id="determinationStatusId"
      :is-for-reset-determination="isForResetDetermination"
      :proposal-request-id="Number(proposalRequestId)"
      :proposal-request-number="proposalRequest.proposalNumber"
      @on-cancel="onCancelDeterminationHandler"
      @saved="onSavedDeterminationHandler"
    />

    <status-transition
      v-if="toggleStatusCard && proposalRequestStatusTransitions.length > 0"
      :statuses="proposalRequestStatusTransitions"
      title="Cambiar Estatus"
      @on-close="toggleStatusCard = false"
      @on-continue="onSwitchStatus"
    />

    <recommend-evaluation
      v-if="showRecommendPanel"
      :final-score="score"
      :proposal-request-id="Number(proposalRequestId)"
      :proposal-request-status="recommendationPanelOptions"
      @on-cancel="onRecommendedEvaluationCancel"
      @on-proposal-status-change="onProposalStatusChange"
    />

    <board class="mb-4" :details="boardConfig" />

    <q-tab :active-tab="currentIndexTab" nav-class="text-nowrap">
      <q-tab-item
        v-if="isProponentOrSupplier || canViewProposalTabs"
        active
        lazy
        :tabindex="0"
        title="Perfil Proponente"
        @click="onActiveTab(detailsInfoTabs.PerfilProponente)"
      >
        <profile-tab
          :can-view-contract-info="canViewContractInfo"
          :proposal-request-id="Number(proposalRequestId)"
          :proposal-request-info="proposalRequest"
        />
      </q-tab-item>
      <q-tab-item
        v-if="showProposalDetailTab"
        :active="currentIndexTab === detailsInfoTabs.DetallePropuesta"
        lazy
        :tabindex="1"
        title="Detalles de la Propuesta"
        @click="onActiveTab(detailsInfoTabs.DetallePropuesta)"
      >
        <proposal-details :proposal-request-id="proposalRequestId" />
      </q-tab-item>
      <q-tab-item
        v-if="canViewProposalTabs"
        :active="currentIndexTab === detailsInfoTabs.DocumentosPropuesta"
        lazy
        :tabindex="2"
        title="Documentos Propuesta"
        @click="onActiveTab(detailsInfoTabs.DocumentosPropuesta)"
      >
        <proposal-documents-tab
          :bus="bus"
          :can-submit-amendmnet="showSubmitAmendmentBtn"
          :proposal-request-id="Number(proposalRequestId)"
          @on-proposal-status-change="getProposalRequest"
        />
      </q-tab-item>
      <q-tab-item
        v-if="showEvaluationTab"
        :active="currentIndexTab === detailsInfoTabs.Evaluation"
        lazy
        :tabindex="3"
        title="Evaluación"
        @click="onActiveTab(detailsInfoTabs.Evaluation)"
      >
        <evaluators-tab
          :academic-year-id="academicYearId"
          :bus="bus"
          :proposal-request-id="Number(proposalRequestId)"
          :rubric-id="rubricId"
          @ready="onEvaluationLoad"
          @refresh="refreshInfo"
          @score-change="onScoreChange"
        />
      </q-tab-item>
      <q-tab-item
        v-if="showContractTab"
        :active="currentIndexTab === detailsInfoTabs.Contratacion"
        lazy
        :tabindex="4"
        title="Contratación"
        @click="onActiveTab(detailsInfoTabs.Contratacion)"
      >
        <contrat-tab :proposal-request-id="Number(proposalRequestId)" />
      </q-tab-item>
      <q-tab-item
        v-if="showSeparationFunds"
        :active="currentIndexTab === detailsInfoTabs.SeparationFondos"
        lazy
        :tabindex="5"
        title="Separación Fondos"
        @click="onActiveTab(detailsInfoTabs.SeparationFondos)"
      >
        <separation-of-funds
          ref="separationOfFunds"
          :fiscal-year-id="this.proposalRequest.academicYearId"
          :proposal-request-id="Number(proposalRequestId)"
          :proposal-request-info="proposalRequest"
          @refresh="refreshInfo"
        />
      </q-tab-item>
      <q-tab-item
        v-if="showContractDocumentTab"
        :active="currentIndexTab === detailsInfoTabs.DocumentosContrato"
        lazy
        :tabindex="6"
        title="Documentos de Proveedor"
        @click="onActiveTab(detailsInfoTabs.DocumentosContrato)"
      >
        <contract-documents-tab
          :bus="bus"
          :proposal-request-id="Number(proposalRequestId)"
          :show-submit="showSubmitDocumentButton"
          @validateStatus="getAllSubmitContractDocuments"
        />
      </q-tab-item>
      <q-tab-item
        :active="currentIndexTab === detailsInfoTabs.Bitácora"
        lazy
        :tabindex="7"
        title="Bitácora"
        @click="onActiveTab(detailsInfoTabs.Bitácora)"
      >
        <bitacora-manager />
      </q-tab-item>
      <q-tab-item
        v-if="canViewProposalTabs"
        :active="currentIndexTab === detailsInfoTabs.Historial"
        lazy
        :tabindex="8"
        title="Historial"
        @click="onActiveTab(detailsInfoTabs.Historial)"
      >
        <historial-tab :proposal-request-id="Number(proposalRequestId)" />
      </q-tab-item>
    </q-tab>
  </div>
</template>
<script>
import Vue from 'vue';
import Board from 'Board';
import PageHeader from 'PageHeader';
import { QTab, QTabItem } from '@/components/common/q-tabs';
import EvaluatorsTab from '@/views/provider/proposalHistory/tabs/EvaluatorsTab.vue';
import ProfileTab from '@/views/provider/proposalHistory/tabs/ProfileTab.vue';
import HistorialTab from '@/views/provider/proposalHistory/tabs/HistorialTab.vue';
import ProposalDocumentsTab from '@/views/provider/proposalHistory/tabs/ProposalDocumentsTab.vue';
import SeparationOfFunds from '@/views/provider/proposalHistory/tabs/SeparationOfFundsTabV2.vue';
import RecommendEvaluation from '@/views/provider/proposalHistory/components/RecommendEvaluation.vue';
import ContratTab from '@/views/provider/proposalHistory/tabs/ContractTab.vue';

import separationFundsReportTypes from '@/views/provider/proposalHistory/separationFundsReportTypes';
import ContractDocumentsTab from '@/views/provider/proposalHistory/tabs/ContractDocumentsTab.vue';
import {
  getProposalRequest,
  getSeparationFundsReport,
  getCertifiedAvailabilitySFReport,
  getCertificationSFReport,
  isAllContractDocumentSubmit,
  getProposalDocumentBulk,
  getContractDocumentBulk,
  getProposalStatusTransition,
  changeProposalStatus,
  getProposalRequesReport,
} from '@/modules/serviceProposalHistory/api';
import {
  proposalRequestStatusGroup,
  proposalRequestStatus,
} from '@/utils/constants/proposalRequestStatus.js';
import _generalApi from '@/modules/app/api';

import tabsId from '@/views/provider/proposalHistory/tabs/tabsId';
import roles from '@/utils/constants/roles.js';
import alertMixin from 'utils/mixins/alert.mixin';
import StatusTransition from './components/StatusTransition.vue';
import {
  ProposalDetails,
  BitacoraManager,
} from '@/views/infra/proposalProcess/components';
import ProposalRequestDetermination from '@/views/infra/proposalProcess/components/ProposalRequestDetermination.vue';

//constants
import proposalArea from '@/utils/shared/constants/proposalArea.js';

import { getProposalDeterminationDocuments as _getProposalDeterminationDocuments } from '@/modules/proposalProcess/api.js';

export default {
  name: 'ServiceProposalDetail',
  components: {
    ProposalDetails,
    Board,
    QTab,
    QTabItem,
    EvaluatorsTab,
    PageHeader,
    HistorialTab,
    ProposalDocumentsTab,
    ProfileTab,
    SeparationOfFunds,
    ContractDocumentsTab,
    ContratTab,
    RecommendEvaluation,
    StatusTransition,
    BitacoraManager,
    ProposalRequestDetermination,
  },
  mixins: [alertMixin],
  data: () => ({
    proposalRequestStatus,
    pageHeaderConfig: {
      icon: 'fas fa-user-tie',
      title: 'Propuesta de Servicio',
      routes: ['Proveedor', 'Propuesta de Servicio'],
    },
    proposalRequest: null,
    bus: new Vue(),
    currentIndexTab: 0,
    showRecommendPanel: false,
    showAssigmentButton: false,
    isAllContractSubmit: true,
    score: 0,
    toggleStatusCard: false,
    proposalRequestStatusTransitions: [],
    showDetermination: null,
    determinationStatusId: null,
  }),
  computed: {
    detailsInfoTabs() {
      return tabsId;
    },
    rubricRequired() {
      return this.proposalRequest.rubricRequired;
    },
    rubricId() {
      const rubrics = this.proposalRequest?.rubrics ?? [];
      return rubrics.length ? rubrics[0]?.id : 0;
    },
    selectedReport() {
      return (reportType) => {
        const params = {
          proposalRequestId: this.proposalRequestId,
        };
        switch (reportType) {
          case separationFundsReportTypes.SeparationFunds:
            return getSeparationFundsReport(params).then((res) => res.data);
          case separationFundsReportTypes.FundsAvailability:
            return getCertifiedAvailabilitySFReport(params).then(
              (res) => res.data
            );
          case separationFundsReportTypes.Certification:
            return getCertificationSFReport(params).then((res) => res.data);
          default: {
            return null;
          }
        }
      };
    },
    showSeparationFundsReportsButton() {
      return (
        this.currentIndexTab == tabsId.SeparationFondos &&
        this.userHasPermissions('proposal.administrator') &&
        this.showContractTab
      );
    },
    showSubmitAmendmentBtn() {
      return (
        this.currentIndexTab == tabsId.DocumentosPropuesta &&
        [proposalRequestStatus.NotRecommendedInformation].includes(
          this.proposalRequest.proposalRequestStatus.id
        )
      );
    },
    showSubmitDocumentButton() {
      return this.showContractDocumentTab && !this.isAllContractSubmit;
    },
    showSeparationFunds() {
      return (
        this.userHasPermissions('provider.proposal.showproposals') &&
        this.proposalRequest &&
        [
          proposalRequestStatus.SentBudget,
          proposalRequestStatus.ContractOffice,
          proposalRequestStatus.SecretaryOffice,
          proposalRequestStatus.PendingShippingOGP,
          proposalRequestStatus.OGPApprovalApplication,
          proposalRequestStatus.OGPApproval,
          proposalRequestStatus.ReadyForSignature,
          proposalRequestStatus.SignedContract,
          proposalRequestStatus.RegisteredContractOC,
          proposalRequestStatus.RecommendedCondition,
          proposalRequestStatus.RecommendedHiring,
          proposalRequestStatus.FundSeparation,
          proposalRequestStatus.SentToSecretaryOffice,
          proposalRequestStatus.PendingOGP,
          proposalRequestStatus.SentOGP,
          proposalRequestStatus.ContractDrafting,
          proposalRequestStatus.InSigningProcessSAEE,
          proposalRequestStatus.InSigningProcessSupplier,
          proposalRequestStatus.InSigningProcessSecretary,
          proposalRequestStatus.Signed,
          proposalRequestStatus.OfficeSecretaryForSignature,
          proposalRequestStatus.DeliveredForObligation,
          proposalRequestStatus.InSigningProcessLegalDivision,
          proposalRequestStatus.RegistryComptrollerOffice,
          proposalRequestStatus.InApprovalAndPOCreationProcess,
        ].includes(this.proposalRequest.proposalRequestStatus.id)
      );
    },
    recommendationPanelOptions() {
      switch (this.proposalRequest?.proposalRequestStatus.id) {
        case proposalRequestStatus.Evaluated:
          return proposalRequestStatusGroup.PreliminaryRecommendation;
        case proposalRequestStatus.PreliminaryRecommended:
        case proposalRequestStatus.NotPreliminaryRecommended:
          return proposalRequestStatusGroup.FinalRecommendation;
        case proposalRequestStatus.NotRecommendedInformationSubmitted: {
          let statusOptions = {
            ...proposalRequestStatusGroup.FinalRecommendation,
          };
          statusOptions.options = statusOptions.options.filter(
            (o) => o.id != proposalRequestStatus.NotRecommendedInformation
          );
          return statusOptions;
        }
        default: {
          return null;
        }
      }
    },
    showRecommendationButton() {
      return (
        this.currentIndexTab == tabsId.Evaluation &&
        this.recommendationPanelOptions != null
      );
    },
    showProposalDetailTab() {
      return (
        this.rubricRequired &&
        (this.isProponentOrSupplier || this.canViewProposalTabs)
      );
    },
    showEvaluationTab() {
      return this.rubricRequired && this.canViewProposalTabs;
    },
    showContractTab() {
      return (
        this.userHasPermissions('provider.proposal.showproposals') &&
        this.proposalRequest &&
        [
          proposalRequestStatus.SentBudget,
          proposalRequestStatus.ContractOffice,
          proposalRequestStatus.SecretaryOffice,
          proposalRequestStatus.PendingShippingOGP,
          proposalRequestStatus.OGPApprovalApplication,
          proposalRequestStatus.OGPApproval,
          proposalRequestStatus.OfficeSecretaryForSignature,
          proposalRequestStatus.ReadyForSignature,
          proposalRequestStatus.SignedContract,
          proposalRequestStatus.RegisteredContractOC,
          proposalRequestStatus.RecommendedHiring,
          proposalRequestStatus.FundSeparation,
          proposalRequestStatus.SentToSecretaryOffice,
          proposalRequestStatus.PendingOGP,
          proposalRequestStatus.SentOGP,
          proposalRequestStatus.ContractDrafting,
          proposalRequestStatus.InSigningProcessSAEE,
          proposalRequestStatus.InSigningProcessSupplier,
          proposalRequestStatus.InSigningProcessSecretary,
          proposalRequestStatus.Signed,
          proposalRequestStatus.DeliveredForObligation,
          proposalRequestStatus.InSigningProcessLegalDivision,
          proposalRequestStatus.RegistryComptrollerOffice,
          proposalRequestStatus.InApprovalAndPOCreationProcess,
        ].includes(this.proposalRequest?.proposalRequestStatus.id)
      );
    },
    showContractDocumentTab() {
      return (
        (this.userHasPermissions('provider.proposal.showproposals') ||
          this.isProponentOrSupplier) &&
        this.proposalRequest &&
        [
          proposalRequestStatus.SentBudget,
          proposalRequestStatus.ContractOffice,
          proposalRequestStatus.SecretaryOffice,
          proposalRequestStatus.PendingShippingOGP,
          proposalRequestStatus.OGPApprovalApplication,
          proposalRequestStatus.OGPApproval,
          proposalRequestStatus.ReadyForSignature,
          proposalRequestStatus.SignedContract,
          proposalRequestStatus.RegisteredContractOC,
          proposalRequestStatus.RecommendedCondition,
          proposalRequestStatus.OfficeSecretaryForSignature,
          proposalRequestStatus.RecommendedHiring,
          proposalRequestStatus.FundSeparation,
          proposalRequestStatus.SentToSecretaryOffice,
          proposalRequestStatus.PendingOGP,
          proposalRequestStatus.SentOGP,
          proposalRequestStatus.ContractDrafting,
          proposalRequestStatus.InSigningProcessSAEE,
          proposalRequestStatus.InSigningProcessSupplier,
          proposalRequestStatus.InSigningProcessSecretary,
          proposalRequestStatus.Signed,
          proposalRequestStatus.InSigningProcessLegalDivision,
          proposalRequestStatus.RegistryComptrollerOffice,
          proposalRequestStatus.InApprovalAndPOCreationProcess,
        ].includes(this.proposalRequest?.proposalRequestStatus.id)
      );
    },
    proposalRequestId() {
      return this.$route.params.proposalRequestId;
    },
    academicYearId() {
      if (this.proposalRequest) {
        return this.proposalRequest.academicYearId;
      }
      return null;
    },
    pageHeaderActionsConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success ml-2',
          click: () => {
            this.$router.back();
          },
        },
        {
          text: 'Imprimir Propuesta',
          icon: 'fas fa-print',
          variant: 'outline-success',
          click: this.handleDownloadReport,
        },
        {
          text: 'Guardar',
          icon: 'fas fa-save',
          variant: 'success',
          visible: this.currentIndexTab === tabsId.SeparationFondos,
          click: () => this.$refs.separationOfFunds.saveHandler(),
        },
        {
          text: 'Cambiar a Estatus',
          icon: 'fas fa-exchange-alt',
          variant: 'success',
          visible:
            this.canChangeProposalStatus &&
            !this.toggleStatusCard &&
            this.proposalRequestStatusTransitions.length > 0,
          click: () => {
            this.toggleStatusCard = true;
          },
        },
        {
          text: this.recommendationPanelOptions?.title,
          icon: 'fas fa-flag-alt',
          variant: 'success',
          visible: this.showRecommendationButton,
          click: this.onRecommendedEvaluationCancel,
        },
        {
          text: 'Asignar Evaluador',
          icon: 'fas fa-user-plus',
          variant: 'success',
          visible: this.showAssigmentButton,
          click: () => this.bus.$emit('showAssigment', true),
        },
        {
          text: 'Descargar Documentos de la Propuesta',
          icon: 'fas fa-file-download',
          variant: 'success',
          visible: this.canViewProposalDocumentBulkButton,
          click: this.onDownloadProposalDocument,
        },
        {
          text: 'Descargar Documentos del Contrato',
          icon: 'fas fa-file-download text-green pr-1',
          variant: 'outline-success',
          visible: this.canViewContractDocumentBulkButton,
          click: () => this.onDownloadContractDocument(),
        },
        {
          text: 'Someter',
          icon: 'fas fa-flag pr-1',
          variant: 'success',
          visible:
            this.isProponentOrSupplier &&
            this.currentIndexTab === tabsId.DocumentosContrato &&
            (this.showSubmitDocumentButton || this.showSubmitAmendmentBtn),
          click: () => this.submitDocuments(),
        },
      ];
    },
    boardConfig() {
      const proposalRequest = this.proposalRequest
        ? {
            ...this.proposalRequest,
          }
        : {};

      return [
        [
          {
            label: 'Propuesta',
            icon: 'fa fa-calendar',
            data: proposalRequest.proposalNumber,
          },
          {
            label: 'Año Fiscal',
            icon: 'fa fa-calendar',
            data: proposalRequest.academicYearName,
          },
          {
            label: 'Estatus',
            icon: 'fa fa-calendar',
            data: proposalRequest.proposalRequestStatusDescription,
          },
          {
            label: 'Proveedor',
            icon: 'fa fa-calendar',
            data: proposalRequest.companyName,
          },
        ],
      ];
    },
    canViewContractInfo() {
      return [
        proposalRequestStatus.Recommended,
        proposalRequestStatus.RecommendedCondition,
        proposalRequestStatus.SentBudget,
        proposalRequestStatus.ContractOffice,
        proposalRequestStatus.SecretaryOffice,
        proposalRequestStatus.PendingShippingOGP,
        proposalRequestStatus.OGPApprovalApplication,
        proposalRequestStatus.OGPApproval,
        proposalRequestStatus.OfficeSecretaryForSignature,
        proposalRequestStatus.ReadyForSignature,
        proposalRequestStatus.SignedContract,
        proposalRequestStatus.RegisteredContractOC,
        proposalRequestStatus.NotRecommendedInformationSubmitted,
        proposalRequestStatus.RecommendedHiring,
        proposalRequestStatus.FundSeparation,
        proposalRequestStatus.SentToSecretaryOffice,
        proposalRequestStatus.PendingOGP,
        proposalRequestStatus.SentOGP,
        proposalRequestStatus.ContractDrafting,
        proposalRequestStatus.InSigningProcessSAEE,
        proposalRequestStatus.InSigningProcessSupplier,
        proposalRequestStatus.InSigningProcessSecretary,
        proposalRequestStatus.Signed,
        proposalRequestStatus.DeliveredForObligation,
        proposalRequestStatus.InSigningProcessLegalDivision,
        proposalRequestStatus.RegistryComptrollerOffice,
        proposalRequestStatus.InApprovalAndPOCreationProcess,
      ].includes(this.proposalRequest?.proposalRequestStatus?.id);
    },
    canViewProposalDocumentBulkButton() {
      return (
        this.currentIndexTab == tabsId.DocumentosPropuesta &&
        this.userHasPermissions('provider.proposal.document.bulkdownload')
      );
    },
    canViewContractDocumentBulkButton() {
      return (
        this.currentIndexTab == tabsId.DocumentosContrato &&
        this.userHasPermissions(
          'provider.proposal.contractdocument.bulkdownload'
        )
      );
    },
    isProponentOrSupplier() {
      return [roles.Proponente, roles.Provider].includes(this.userRole);
    },
    canViewProposalTabs() {
      return this.userHasPermissions('provider.proposal.showproposals');
    },
    canChangeProposalStatus() {
      return this.userHasPermissions('provider.proposal.canchangestatus');
    },
    isAdministrator() {
      return [
        roles.Administrador,
        roles.AdminProvider,
        roles.AdminIL,
        roles.UMESRAdmin,
        roles.AdminSAEE,
        roles.BecaAsistencia,
      ].includes(this.userRole);
    },
    canViewProposalDocuments() {
      return [
        roles.Administrador,
        roles.Provider,
        roles.Proponente,
        roles.AdminProvider,
        roles.AdminIL,
        roles.UMESRAdmin,
        roles.AdminSAEE,
        roles.BecaAsistencia,
      ].includes(this.userRole);
    },
    canDetermineProposalRequest() {
      return (
        [
          proposalRequestStatus.Submitted,
          proposalRequestStatus.PartialRecommendation,
        ].includes(this.proposalRequest?.proposalRequestStatus?.id) &&
        this.userHasPermissions('provider.proposal.determination.infra.view') &&
        !this.rubricRequired
      );
    },
    canRecommendProposalRequest() {
      return this.userHasPermissions(
        'provider.proposal.determination.infra.recommended.view'
      );
    },
    canNotRecommendProposalRequest() {
      return this.userHasPermissions(
        'provider.proposal.determination.infra.notrecommended.view'
      );
    },
    isPartialRecomendationStatus() {
      return (
        this.proposalRequest?.proposalRequestStatus?.id ==
        proposalRequestStatus.PartialRecommendation
      );
    },
    isProvisionalRemedy() {
      return this.proposalRequest.areaId == proposalArea.ProvisionalRemedy;
    },
    isProfessionalServices() {
      return this.proposalRequest.areaId == proposalArea.ProfessionalServices;
    },
    provisionalRemedyDocumentRequired() {
      const {
        staticValue = 'false',
      } = this.sysParameters.ProvisionalRemedyProposalDocumentRequired;
      return JSON.parse(staticValue.toLowerCase());
    },
  },
  async created() {
    const tap = this.$route.params.tapIndex;

    if (tap) {
      this.currentIndexTab = tap;
    }

    this.bus.$on('assignedEvaluator', async () => {
      await this.getProposalRequest();
    });

    await this.getProposalRequest();
    await this.getAllSubmitContractDocuments();
  },
  methods: {
    async handleDownloadReport() {
      await getProposalRequesReport(this.proposalRequestId).then((response) => {
        _generalApi.ConvertToBlob(response.data);
      });
    },
    async submitDocuments() {
      if (this.showSubmitDocumentButton) {
        this.bus.$emit('submitContractDocument');
      } else if (this.showSubmitAmendmentBtn) {
        this.bus.$emit('submitAmendmentDocument');
      }
    },
    async downloadReportHandler(reportType) {
      await this.selectedReport(reportType).then((report) =>
        _generalApi.ConvertToBlob(report)
      );
    },
    onRecommendedEvaluationCancel() {
      this.showRecommendPanel = !this.showRecommendPanel;
    },
    async onSwitchStatus(model) {
      try {
        await changeProposalStatus(
          Number(this.proposalRequestId),
          model.status.id,
          {
            comment: model.comment,
            poBalance: model.poBalance,
            poNumber: model.poNumber,
          }
        );

        this.ShowToast(
          'Proceso Exitoso',
          `El estatus se ha cambiado exitosamente.`,
          'success'
        );

        this.toggleStatusCard = false;

        await this.getProposalRequest();
      } catch (err) {
        if (err.response?.data?.message) {
          this.ShowToast('Alerta', `${err.response.data.message}`, 'error');
        } else {
          this.ShowToast('', 'Error al intentar cambiar de estatus.', 'error');
        }
      }
    },
    async onProposalStatusChange() {
      this.onRecommendedEvaluationCancel();
      await this.getProposalRequest();
    },
    async getProposalRequest() {
      await getProposalRequest(this.proposalRequestId).then(async (res) => {
        this.proposalRequest = { ...res.data };

        await getProposalStatusTransition(
          this.proposalRequest?.proposalRequestStatus.id
        ).then((res) => {
          this.proposalRequestStatusTransitions = res.data;
        });
      });
    },
    async getAllSubmitContractDocuments() {
      await isAllContractDocumentSubmit(this.proposalRequestId).then((res) => {
        this.isAllContractSubmit = res.data;
      });
    },
    onEvaluationLoad() {
      this.showAssigmentButton =
        this.currentIndexTab == tabsId.Evaluation &&
        this.userHasPermissions('proposal.administrator') &&
        [
          proposalRequestStatus.Submitted,
          proposalRequestStatus.Assigned,
          proposalRequestStatus.EvaluationProcess,
          proposalRequestStatus.NotRecommendedInformationSubmitted,
        ].includes(this.proposalRequest.proposalRequestStatus.id);
    },
    onActiveTab(indexTab) {
      this.currentIndexTab = Number(indexTab);
      this.showRecommendPanel = false;
    },
    async refreshInfo() {
      await this.getProposalRequest();
    },
    async onDownloadProposalDocument() {
      await getProposalDocumentBulk(this.proposalRequest.proposalRequestId)
        .then((res) => {
          _generalApi.ConvertToBlob(res.data);
        })
        .catch((err) => {
          this.ShowToast('Error', err.response.data.message);
        });
    },
    async onDownloadContractDocument() {
      await getContractDocumentBulk(this.proposalRequest.proposalRequestId)
        .then((res) => {
          _generalApi.ConvertToBlob(res.data);
        })
        .catch((err) => {
          this.ShowToast('Error', err.response.data.message);
        });
    },
    onScoreChange(score) {
      this.score = score;
    },
    async onOpenDeterminationHandler(statusId) {
      if (this.isProvisionalRemedy && this.provisionalRemedyDocumentRequired) {
        const {
          data: documents = [],
        } = await _getProposalDeterminationDocuments(this.proposalRequestId);
        if (!documents.length) {
          this.ShowToast(
            'Alerta',
            `Al menos un documento de respaldo es requerido para determinar la propuesta.`,
            'error'
          );
          return;
        }
      }

      this.determinationStatusId = statusId;
      this.isForResetDetermination = false;
      this.showDetermination = true;
    },
    onCancelDeterminationHandler() {
      this.determinationStatusId = null;
      this.isForResetDetermination = false;
      this.showDetermination = null;
    },
    async onSavedDeterminationHandler() {
      this.onCancelDeterminationHandler();
      await this.$refs?.proposalStatusHistoryRef?.getProposalRequestStatusHistory(); //refresh status history comp
      await this.getGeneralInformation();
    },
    onResetDeterminationHandler() {
      this.isForResetDetermination = true;
      this.showDetermination = true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

.custom-header__container {
  display: flex;
  justify-content: space-between;
}

.custom-action-rigth__container {
  height: 47px;
  margin-top: 50px;
  border-bottom: #eaecef 1px solid;
}

::v-deep .reports-dropdown {
  .btn {
    color: map-get($colors, 'green');
    font-size: 1rem;
    font-weight: normal;
    padding: 2px 10px;
  }
}

@media only screen and (max-width: 768px) {
  ::v-deep .reports-dropdown {
    margin-bottom: 0.5rem;
    margin-left: 0.5rem;
    .btn {
      width: 102%;
    }
  }
}
</style>
